export default {
  custom_additive: {
    placeholder: 'Aangepaste optie toevoegen',
  },
  buttons: {
    add: 'Toevoegen',
  },
};
